module.exports = __webpack_public_path__ + "static/media/ic-informacao.f6d5daf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TariffSubscribeModal/assets/ic-informacao.svg
// module id = 1239
// module chunks = 0